import { PresetKey } from '../types';
export const Preset = {
    Thumbnail: [
        PresetKey.Default500wJpeg,
        PresetKey.Default500wWebp,
        PresetKey.Default1000wJpeg,
        PresetKey.Default1000wWebp,
        PresetKey.Default1500wJpeg,
        PresetKey.Default1500wWebp,
    ],
    Mini: [
        PresetKey.Jpeg60x60,
        PresetKey.Webp60x60,
        PresetKey.Jpeg120x120,
        PresetKey.Webp120x120,
        PresetKey.Jpeg180x180,
        PresetKey.Webp180x180,
    ],
};
